import { AVAILABLE_OFFER_TYPE_COMBINATIONS } from '../constants';
import { type FOfferType } from '../types';

export function isAvailableOfferTypeCombination(offerType: FOfferType): boolean {
  return AVAILABLE_OFFER_TYPE_COMBINATIONS.some(c => (c & offerType) === offerType);
}
